import { render, staticRenderFns } from "./Complain.vue?vue&type=template&id=5e590a56&"
import script from "./Complain.vue?vue&type=script&lang=js&"
export * from "./Complain.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports